module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1283.d8303ddb.png";